module.exports = __webpack_public_path__ + "static/media/Horsea_gaussian2.bbc91f97.png";